import { graphql } from "gql/apollo";

export const CreateIntegration = graphql(/* GraphQL */ `
	mutation CreateGenetecIntegration($params: CreateGenetecIntegrationParams!) {
		createGenetecIntegration(params: $params) {
			success
			error {
				message
			}
			integration: genetecIntegration {
				...GenetecIntegrationFields
			}
		}
	}
`);
